// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_nq-5";
export var filledCircle = "_nq-4";
export var historyEntry = "_nq-3";
export var messageSideLeft = "_nq-1";
export var messageSideRight = "_nq-2";
export var orderTrackingCarouselWrapper = "_nq-6";
export var orderTrackingInfoContainer = "_nq-0";